<template>
  <div >
    <div class="picShow">
      <el-row>
        <el-col class="titlej" :span="20" :offset="2">
          <h1>Ehre</h1>
        </el-col>
        <el-col class="titlej" :span="20" :offset="2">
          <p><i >Patent</i>Es ist eine Anerkennung für die innovativen Leistungen unseres Teams und ein Beweis für unsere kontinuierliche Erforschung und Innovation.
            Wir werden weiterhin den Innovationsgeist aufrechterhalten und Kunden qualitativ hochwertige Produkte und Dienstleistungen anbieten</p>
        </el-col>
        <el-col class="titlej" :span="20" :offset="2">
          <p><i>Prüfbericht</i>Beide sind Zeugen unserer Produktqualität und treibende Kraft für unsere kontinuierliche Verbesserung und Weiterentwicklung.
            Wir werden weiterhin bestrebt sein, die Produktqualität zu verbessern und Kunden sicherere und zuverlässigere Produkte zu bieten.</p>
        </el-col>
        <el-col :xs="0" :sm="0" :md="3" :lg="3" ></el-col>
        <el-col :xs="24" :sm="24" :md="18" :lg="18">
          <p style="padding: 10px">
            <el-button-group>
              <el-button v-for="(item,index) in buttons" :key="index" :class="{selected:selectedBtn===index}"
                         @click="selectedBtn = index"
              >
                {{item}}
              </el-button>

            </el-button-group>
          </p>
          <!-- 荣誉资质-->
          <el-row :gutter="20" class="imgs" style="padding: 20px">
            <el-col :xs="12" :sm="12" :md="8" :lg="8" v-for="(item,index) in datas" :key="index">

              <div class="demo-image__placeholder">

                <div class="block demo-image__lazy" >

                  <el-image
                          :src="item.src"
                          :append-to-body = "true"
                          :preview-src-list="item.srcList"

                  >
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                  <span class="demonstration">{{item.title}}</span>
                </div>

              </div>

            </el-col>


          </el-row>

        </el-col>
      </el-row>
    </div>


  </div>
</template>

<script>
  import request from "@/utils/request";

  export default {
    name: "HonorQualification",
    data() {
      return {
        datas:[],
        buttons:["Zertifikat","Patent"],
        selectedBtn:0,



      }
    },
    methods:{
      getImgs(types){
        let that= this
        that.datas=[],
                request.get("/honor/zh/"+types).then(res =>{


                  for (let i = 0; i < res.data.length; i++) {
                    let data={
                      src:"",
                      srcList:[],
                      title:""
                    }

                    data.src=res.data[i].thumbnail;
                    data.srcList.push(res.data[i].url);
                    data.title=res.data[i].title
                    that.datas.push(data)

                  }

                }).catch((res)=>{
                })
      }
    },
    beforeMount() {
      this.getImgs("SGS")
    },
    watch: {
      selectedBtn: {
        handler(news, old) {
          if (news == 0) {
            this.getImgs("SGS")

          }else {
            this.getImgs("patent")
          }

        }
      }
    }
  }
</script>

<style scoped>



  .el-row {
    margin-bottom: 20px;

  }
  .titlej{
    animation: moveUp 2s ease-in-out forwards;
  }
  imgs{
    padding-top: 100px;
  }
  .imgs .el-col{
    margin-top: 30px;

    opacity: 0;
    animation: moveUp 1s ease-in-out forwards;
  }



  .el-col h1{
    padding: 80px 0;
    text-align: center;


  }
  .el-col p{
    text-align: center;
    font-size: 20px;
    color: #333;
    line-height: 48px


  }
  .picShow{
    background-color: #f4f8fb;
    overflow: hidden;
  }
  .demo-image__placeholder{
    padding: 40px 40px 10px 40px;
    background-color: #ffffff;
    text-align: center;

  }

  .demonstration{
    margin-top: 10px;
    display: block;
    font-size: 18px;
    color: #333;
    line-height: 60px;
    width: 100%;
    border-top: 1px solid #cccccc;



  }
  .el-col p i{
    font-style: unset;font-weight: bolder
  }


  @media screen and (max-width: 768px){



    .el-col h1{
      padding: 50px 0 30px 0;
      text-align: center;


    }
    .el-col p{
      text-align: center;
      font-size: 1rem;
      color: #333;
      line-height: 2rem


    }

    .imgs .el-col{
      margin-top: 20px;

      opacity: 0;
      animation: moveUp 1s ease-in-out forwards;
    }
    .demo-image__placeholder{
      padding: 10px ;
      background-color: #ffffff;
      text-align: center;

    }
    .demonstration{

      display: block;
      font-size: 1rem;
      color: #333;
      line-height: 2rem;
      width: 100%;
      border-top: 1px solid #cccccc;



    }

  }


  .selected{
    background-color: #409eff;
    color: #ffffff;
  }



  .imgs .el-col:nth-child(2) {
    animation-delay: 1s;
  }

  .imgs .el-col:nth-child(3) {
    animation-delay: 2s;
  }
  .imgs .el-col:nth-child(4) {
    animation-delay: 3s;
  }
  .imgs .el-col:nth-child(5) {
    animation-delay: 4s;
  }
  .imgs .el-col:nth-child(6) {
    animation-delay: 5s;
  }
  .imgs .el-col:nth-child(7) {
    animation-delay: 6s;
  }
  .imgs .el-col:nth-child(8) {
    animation-delay: 7s;
  }
  .imgs .el-col:nth-child(9) {
    animation-delay: 8s;
  }
  .imgs .el-col:nth-child(10) {
    animation-delay: 9s;
  }
  .imgs .el-col:nth-child(11) {
    animation-delay: 10s;
  }
  .imgs .el-col:nth-child(12) {
    animation-delay: 11s;
  }
  .imgs .el-col:nth-child(13) {
    animation-delay: 12s;
  }
  .imgs .el-col:nth-child(14) {
    animation-delay: 13s;
  }
  .imgs .el-col:nth-child(15) {
    animation-delay: 14s;
  }
  .imgs .el-col:nth-child(16) {
    animation-delay: 15s;
  }
  .imgs .el-col:nth-child(17) {
    animation-delay: 5s;
  }
  .imgs .el-col:nth-child(18) {
    animation-delay: 16s;
  }
  .imgs .el-col:nth-child(19) {
    animation-delay: 17s;
  }
  .imgs .el-col:nth-child(20) {
    animation-delay: 18s;
  }
</style>